import React from "react";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";



export default function Breadcrumb({ title, id, navigate, path }) {
  function handleClick(event) {
    event.preventDefault();
    navigate(path)
    console.info('You clicked a breadcrumb.');
  }
  const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" href="/" onClick={handleClick} >
      {title}
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
    // href="/material-ui/getting-started/installation/"
    // onClick={handleClick}
    >
      {id}
    </Link>,

  ];

  return (
    <Stack spacing={2}>

      <Breadcrumbs separator={<FontAwesomeIcon icon={icon({ name: "angle-right" })} color="#333333" />} aria-label="breadcrumb" >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}